import { isFTTXConnection } from 'Quotes/types/connectionType';
import { ProductType } from 'Quotes/types/productTypes';
import { IPriceData, IQuote } from 'Quotes/types/store';

export const isFttpAggregationPossible = (quote: IQuote, selectedPrice: IPriceData) => {
  return (
    !isFTTXConnection(quote.connectionType) &&
    selectedPrice.fttp_aggregation_charge !== null &&
    selectedPrice.fttp_aggregation_charge !== undefined &&
    quote.productType !== ProductType.NNI2CCT
  );
};

export const isFTTXQuote = (quote: IQuote) => {
  return isFTTXConnection(quote.connectionType);
};